import { ENUM__page_type } from '@/enums/ENUM__page_type';
import { use_effect } from '@/hooks/_base/use_effect';
import { use_navigate_ud } from '@/hooks/_base/use_navigate_ud';
import { use_slice_generation, use_slice_user, use_slice_workspace } from '@/hooks/store/use_slices';
import { set_current_generation, set_current_workspace, try_set_default_workspace } from '@/utils/utils_client_workspace_child_entity_viewers';
import { useParams } from 'react-router-dom';

export function WATCHER_SLUG__page_user_task() {
  const navigate = use_navigate_ud();

  const { user_task_id: user_task_id_from_slug } = useParams();

  const { auth_token } = use_slice_user(['auth_token']);
  const { user_tasks_map, user_task_current } = use_slice_generation(['user_tasks_map', 'user_task_current']);
  const { is_all_data_loaded, workspace_current } = use_slice_workspace(['is_all_data_loaded', 'workspace_current']);

  /*
   * EFFECTS
   */
  use_effect(() => void set_entity_and_workspace_from_slug(), [is_all_data_loaded]);

  use_effect(() => {
    if (!is_all_data_loaded) return;
    if (user_task_id_from_slug === user_task_current._id) return; //slug and data are already synced

    //could be stub when from user deleted permissions to view entities
    let entity_id = user_task_current.is_stub() ? '' : user_task_current._id;

    let url = ENUM__page_type.BUILD_PATH_USER_TASK(entity_id);

    void navigate(url, { replace: true, keep_search_params: true });
  }, [user_task_current, is_all_data_loaded, user_task_id_from_slug]);

  /*
   * METHODS
   */

  async function set_entity_and_workspace_from_slug() {
    if (!auth_token) return; //not authorized
    if (!is_all_data_loaded) return; // not all data loaded

    //already equal
    if (user_task_current._id === user_task_id_from_slug && !user_task_current.is_stub()) return set_current_workspace(user_task_current.workspace_id);

    if (!user_task_current.is_stub()) return; //already established

    let entity_from_slug = [...user_tasks_map.values()].find(item => item._id == user_task_id_from_slug);

    if (entity_from_slug) {
      let generation = entity_from_slug.getMostRecentGeneration();

      await set_current_generation(generation._id);

      set_current_workspace(entity_from_slug.workspace_id);
    } else if (workspace_current.is_stub()) {
      await try_set_default_workspace();
    }
  }

  return <></>;
}
